import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroBanner = () => {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20cinema%20interior%20with%20rich%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20artistic%20abstract%20bokeh%20lights%2C%20elegant%20movie%20theater%20ambiance%2C%20dramatic%20warm%20tones%20with%20deep%20crimson%20and%20amber%20highlights%2C%20cinematic%20atmosphere%2C%20soft%20glow%2C%20high%20contrast%20beautiful%20lighting&width=1600&height=800&seq=hero-bg-main&orientation=landscape"
        alt="红桃视频"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-50" />
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-2xl backdrop-blur-sm transition-transform duration-500 hover:scale-110 cursor-pointer">
            <i className="ri-play-circle-fill text-3xl text-background-50"></i>
          </div>
          <div>
            <h1 className="text-3xl md:text-5xl font-bold text-background-50 tracking-wide" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('site.name')}
            </h1>
            <p className="text-xs md:text-sm text-background-200/80 mt-0.5">
              {t('site.slogan')}
            </p>
          </div>
        </div>
        <p className="text-base md:text-lg text-background-200 max-w-lg text-center leading-relaxed mb-8">
          {t('home.hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
          <div className="relative flex-1 w-full">
            <input
              type="text"
              placeholder={t('nav.search') || '搜索你喜欢的影片...'}
              className="w-full pl-10 pr-4 py-3 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/25 text-background-50 placeholder:text-background-300 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-300/50 transition-all duration-300"
            />
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-background-300 text-base"></i>
          </div>
          <Link
            to="/category/all"
            className="whitespace-nowrap px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-full transition-all duration-300 cursor-pointer hover:scale-105"
          >
            {t('home.hero.cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;